class PolicyConsent extends HTMLElement {
  connectedCallback() {
    this.form = this.closest('form');
    this.checkbox = this.querySelector('input[type="checkbox"]');
    this.message = this.querySelector('[aria-live]');
    if (!this.form || !this.checkbox) return;
    this.controller?.abort();
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    this.checkbox.addEventListener('change', () => this.update(), options);
    this.form.addEventListener('submit', event => {
      if (event.submitter?.name !== 'checkout' || this.checkbox.checked) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      this.checkbox.focus();
      this.checkbox.reportValidity();
    }, { ...options, capture: true });
    this.update();
  }
  disconnectedCallback() { this.controller?.abort(); }
  update() {
    this.form.querySelectorAll('[name="checkout"]').forEach(button => {
      button.disabled = !this.checkbox.checked;
    });
    this.message.hidden = this.checkbox.checked;
  }
}
if (!customElements.get('policy-consent')) customElements.define('policy-consent', PolicyConsent);
